import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateOrderDeliveryDTO, CreateOrderDineInDTO, CreateOrderPickupDTO } from "../models/order/order.request";
import { ClientOrderInfoDTO, ClientOrderListItemDTO, ClientOrdersListItemDTO, LiveOrdersDeliveryItemListDTO, LiveOrdersPickUpItemListDTO, LiveOrdersDineInListItemDTO, OrderHistoryDTO } from "../models/order/order.response";
import { OrderStatusType } from "../models/base/OrderStatusType";
import { LiveOrderInfoDTO } from "../models/shared/response";
import { OrderType } from "../models/base/OrderType";


export const orderService = {

    async createDeliveryOrder(localId: string, dto: CreateOrderDeliveryDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/orders/delivery`, dto);
        return data;
    },

    async createPickupOrder(localId: string, dto: CreateOrderPickupDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/orders/pickup`, dto);
        return data;
    },

    async createDineInOrder(localId: string, dto: CreateOrderDineInDTO): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/orders/dine-in`, dto);
        return data;
    },

    async getUsersOrders(userId: string, startDate: Date, endDate: Date, orderType: OrderType, statusType: OrderStatusType): Promise<ApiResponse<ClientOrderListItemDTO[]>> {
        console.log("Fetching orders with params:", { userId, startDate, endDate, orderType, statusType });
        const { data } = await api.get<ApiResponse<ClientOrderListItemDTO[]>>(`/users/${userId}/orders`, {
            params: {
                startDate,
                endDate,
                orderType,
                statusType
            }
        });
        return data;
    },

    async changeOrderStatus(localId: string, orderId: string, status: OrderStatusType): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/orders/${orderId}/status`, { status });
        return data;
    },

    async changeOrderStatusToNext(localId: string, orderId: string): Promise<ApiResponse<string>> {
        const { data } = await api.patch<ApiResponse<string>>(`/locals/${localId}/orders/${orderId}/status/next`);
        return data;
    },

    async getUsersOrdersInLocal(userId: string, localId: string): Promise<ApiResponse<ClientOrdersListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<ClientOrdersListItemDTO[]>>(`/users/${userId}/locals/${localId}/orders`);
        return data;
    },

    async getUserOrderInfoInLocal(orderId: string): Promise<ApiResponse<ClientOrderInfoDTO>> {
        const { data } = await api.get<ApiResponse<ClientOrderInfoDTO>>(`/orders/${orderId}/client-info`);
        return data;
    },

    async getDineInLiveOrders(localId: string): Promise<ApiResponse<LiveOrdersDineInListItemDTO[]>> {
        const { data } = await api.get<ApiResponse<LiveOrdersDineInListItemDTO[]>>(`/locals/${localId}/live-orders/dine-in`);
        return data;
    },

    async getDineInLiveOrder(localId: string, orderId: string): Promise<ApiResponse<LiveOrdersDineInListItemDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrdersDineInListItemDTO>>(`/locals/${localId}/live-orders/dine-in/${orderId}`);
        return data;
    },

    async getPickupLiveOrders(localId: string): Promise<ApiResponse<LiveOrdersPickUpItemListDTO[]>> {
        const { data } = await api.get<ApiResponse<LiveOrdersPickUpItemListDTO[]>>(`/locals/${localId}/live-orders/pickup`);
        return data;
    },

    async getPickupLiveOrder(localId: string, orderId: string): Promise<ApiResponse<LiveOrdersPickUpItemListDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrdersPickUpItemListDTO>>(`/locals/${localId}/live-orders/pickup/${orderId}`);
        return data;
    },

    async getDeliveryLiveOrders(localId: string): Promise<ApiResponse<LiveOrdersDeliveryItemListDTO[]>> {
        const { data } = await api.get<ApiResponse<LiveOrdersDeliveryItemListDTO[]>>(`/locals/${localId}/live-orders/delivery`);
        return data;
    },

    async getDeliveryLiveOrder(localId: string, orderId: string): Promise<ApiResponse<LiveOrdersDeliveryItemListDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrdersDeliveryItemListDTO>>(`/locals/${localId}/live-orders/delivery/${orderId}`);
        return data;
    },

    async getLiveOrderInList(localId: string, orderId: string): Promise<ApiResponse<LiveOrderInfoDTO>> {
        const { data } = await api.get<ApiResponse<LiveOrderInfoDTO>>(`/locals/${localId}/live-orders/${orderId}/list`);
        return data;
    },

    async getOrdersHistory(localId: string, date: Date): Promise<ApiResponse<OrderHistoryDTO[]>> {
        const { data } = await api.get<ApiResponse<OrderHistoryDTO[]>>(`/locals/${localId}/orders-history`, {
            params: {
                date
            }
        })
        return data;
    },

    async requestBill(id: string, userId: string): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/orders/${id}/request-bill`, null, {
            params: {
                userId
            }
        });
        return data;
    }


}